<template>
  <div>
    <v-dialog
      v-model="show"
      max-width="550px"
      persistent
      scrollable
      max-height="600px"
    >
      <v-card>
        <v-card-title>
          {{ title }}
          <v-spacer />
          <v-btn
            icon
            @click="$emit('update:showDialog', false)"
          >
            <v-icon color="error">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-container class="px-0">
            <v-row no-gutters>
              <v-col
                cols="12"
                class="mb-3"
              >
                <strong>Line number</strong>
                <v-text-field
                  v-model="lineIns.number"
                  dense
                  outlined
                  clearable
                  color="primary"
                  type="number"
                  hide-details
                />
              </v-col>
              <v-col
                cols="12"
                class="d-flex align-center"
              >
                <h2 class="mr-2">
                  Add Component
                </h2>
                <v-btn
                  icon
                  :disabled="
                    lineIns.components && lineIns.components.length >= 3
                  "
                  @click="addComponent()"
                >
                  <v-icon color="primary">
                    mdi-plus-circle-outline
                  </v-icon>
                </v-btn>
              </v-col>
              <v-divider />
              <v-col cols="12">
                <span
                  v-for="(c, idx) in lineIns.components"
                  :key="idx"
                >
                  <line-component-form
                    :ordinal="idx"
                    :c="c"
                    :component-types="componentTypes"
                    @remove="removeComponent(idx)"
                  />
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions class="px-6 py-3">
          <v-spacer />
          <v-btn
            color="success"
            dense
            :disabled="lineIns.number <= 0"
            @click="save()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { newComponent } from "./templateHelper/Helper.js";
import LineComponentForm from "./LineComponentForm";
export default {
  name: "LineCreate",
  components: {
    LineComponentForm
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    lineData: {
      type: Object,
      default: () => {},
      required: true
    },
    templateMasters: {
      type: Object,
      required: true
    },
    isNew : Boolean
  },
  data() {
    return {
      lineIns: {

      }
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("update:showDialog", val);
      }
    },
    title() {
      return this.isNew ? "New Line" : "Edit Line";
    },
    componentTypes() {
      return this.templateMasters?.components || [];
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.lineIns = this.lineData;
      }
    }
  },
  methods: {
    close() {
      this.$emit("update:showDialog", false);
    },
    addComponent() {
      this.lineIns.components.push(newComponent());
    },
    removeComponent(idxToRemove) {
      this.lineIns.components.splice(idxToRemove, 1);
    },
    save() {
      this.$emit("save", { lineIns: this.lineIns, isNewLine: this.isNew });
    }
  }
};
</script>